var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M18.125 10c0-4.297-3.16-6.875-8.125-6.875S1.875 5.703 1.875 10c0 1.114.767 2.921.887 3.21q.017.038.031.076c.083.225.421 1.508-.918 3.283 1.806.859 3.723-.553 3.723-.553 1.327.7 2.905.859 4.402.859 4.965 0 8.125-2.578 8.125-6.875Z"
  })));
};
export default SvgComment;